<template>
  <div class="filling">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 filling-item">
<!--        <el-card class="box-card">-->
          <h4 class="item-h4" style="float:left;">野外数据填写规范</h4>
        <template v-if="tableData.length>0">
          <el-table
              :data="tableData"
              style="width: 100%">
            <el-table-column
                pr prop="title"
                label=""
                show-overflow-tooltip
                style="text-align: left">
              <template slot-scope="scope">
                <router-link class="list-title" :to="'/detail/'+ scope.row.id+'/'+scope.row.type"
                             :detailId="scope.row.id">{{scope.row.title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label=""
                width="150">
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="totalPage">
          </el-pagination>
        </template>
        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>
<!--        </el-card>-->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import { fetchList} from "@/network/workGuide/fieldData";
import {getObj} from "@/network/workGuide/collectManagement";

export default {
  name: "filling",
  components: { breadcrumb },
  data() {
    return {
    path: '',
    name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      pageSize: 10,
      page: 1,
      totalPage: 0,
      tableData: [],
      type: 'fieldData',
      infoContent:{},
      formInline: {},
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'

    })
  },
  mounted() {
  this.getList()
  },

  created() {
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '工作指南'
    this.childPath = this.$route.path
  },
  methods: {
    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.type
      })).then(response => {
        this.tableData = response.data.data.records
        this.totalPage = response.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    openDetail(id){
      this.$router.push({
        path: '/detail',
        params: {
          id: id,
          infoContent: this.infoContent
        },
      })
      getObj(id).then(res => {
        this.infoContent = res.data.data
      })
      // window.open('http://192.168.0.116:8887/information?id='+id,'_blank')
    },
    onSubmit() {

    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/filling";
::v-deep .el-pagination {
  padding: 20px 5px;
  text-align: center;
}
</style>